<script>
  import { MonitorCog } from 'lucide-svelte';
  import SettingsCard from './shared/SettingsCard.svelte';
  import SettingField from './shared/SettingField.svelte';

  let language = 'English';
  let region = 'Vietnam';
  let dateFormat = 'YYYY-MM-DD';

  const inputClass =
    'h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100';
</script>

<div class="min-h-full bg-slate-100 p-4 lg:p-6">
  <div class="mx-auto max-w-5xl space-y-4">
    <SettingsCard title="System Preferences" description="Language, region, and date formatting.">
      <span slot="actions" class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
        <MonitorCog size={18} />
      </span>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
        <SettingField id="system-language" label="Language">
          <select id="system-language" bind:value={language} class={inputClass}>
            <option>English</option>
            <option>Vietnamese</option>
            <option>Japanese</option>
          </select>
        </SettingField>

        <SettingField id="system-region" label="Region">
          <select id="system-region" bind:value={region} class={inputClass}>
            <option>Vietnam</option>
            <option>United States</option>
            <option>Japan</option>
          </select>
        </SettingField>

        <SettingField id="system-date-format" label="Date Format">
          <select id="system-date-format" bind:value={dateFormat} class={inputClass}>
            <option>YYYY-MM-DD</option>
            <option>DD/MM/YYYY</option>
            <option>MM/DD/YYYY</option>
          </select>
        </SettingField>
      </div>
    </SettingsCard>
  </div>
</div>
